import { gql } from '@apollo/client';

export const GET_REDEMPTION_STATUS = gql`
  query GetRedemptionStatus($ticker: String!, $amount: Int) {
    getRedemptionStatus(ticker: $ticker, amount: $amount) {
      redemptionSharesValidAmount
      redemptionPricePerShare(amount: $amount)
    }
  }
`;
